import { WHY_CARDS } from "../data/site";
import { Target, Lightbulb, PenTool, ArrowDown } from "lucide-react";

const ICONS = { Target, Lightbulb, PenTool };

export default function WhyClickory() {
  return (
    <section id="why" className="relative py-6 md:py-14">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {/* Heading */}
        <div className="relative text-center">
          {/* Ghost / echo text behind — a single wide 'Why Clickory?' */}
          <div
            aria-hidden
            className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.05] blur-[3px] select-none whitespace-nowrap"
          >
            <div className="font-clash-tight text-white text-[60px] md:text-[180px] leading-[1] tracking-[-0.02em]">Why Clickory?</div>
          </div>

          <h2 className="reveal relative font-clash-tight text-white text-[34px] md:text-[68px] leading-[1] tracking-[-0.01em]">Why</h2>
          <h3 className="reveal relative font-clash-tight text-transparent bg-clip-text bg-[linear-gradient(180deg,#EDE9FE_0%,#C4B5FD_50%,#8B5CF6_100%)] text-[50px] md:text-[104px] leading-[1] tracking-[-0.02em] -mt-1">
            Clickory?
          </h3>
        </div>

        {/* Cards container */}
        <div className="reveal mt-10 md:mt-14 rounded-[24px] md:rounded-[36px] border border-white/12 p-3 md:p-10 backdrop-blur-md"
             style={{
               background: "linear-gradient(180deg, rgba(30,27,75,0.35) 0%, rgba(15,23,42,0.20) 100%)",
               boxShadow: "0 30px 80px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.04)",
             }}>
          <div className="grid grid-cols-3 gap-2 md:gap-8">
            {WHY_CARDS.map((c, idx) => {
              const Ic = ICONS[c.icon];
              const isMiddle = idx === 1;
              return (
                <div
                  key={idx}
                  className={`relative rounded-2xl md:rounded-3xl p-3 md:p-8 transition-all duration-500 overflow-hidden ${
                    isMiddle
                      ? "border border-white/15"
                      : "border border-transparent hover:border-white/10"
                  }`}
                  style={
                    isMiddle
                      ? {
                          background:
                            "linear-gradient(180deg, rgba(15,10,45,0.65) 0%, rgba(20,15,55,0.7) 100%)",
                          boxShadow:
                            "0 20px 60px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.05)",
                        }
                      : undefined
                  }
                >
                  {/* Horizontal shine line separator */}
                  <div
                    aria-hidden
                    className="pointer-events-none absolute left-3 right-3 md:left-4 md:right-4 top-[46%] h-px opacity-70"
                    style={{
                      background:
                        "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.35) 50%, transparent 100%)",
                    }}
                  />
                  {/* Top: tagline + down chevron */}
                  <div className="flex items-start justify-between gap-1 md:gap-4">
                    <div className="min-w-0">
                      <div className="font-sf text-white/85 text-[9px] md:text-lg leading-tight">{c.tagLine1}</div>
                      <div className="font-clash text-white text-[15px] md:text-[38px] leading-none mt-0.5 md:mt-1">{c.tagLine2}</div>
                    </div>
                    <div className="shrink-0 w-4 h-4 md:w-8 md:h-8 rounded-full bg-white/95 flex items-center justify-center shadow">
                      <ArrowDown className="w-2 h-2 md:w-4 md:h-4 text-[#4F46E5]" />
                    </div>
                  </div>

                  {/* Icon */}
                  <div className="mt-4 md:mt-10 flex justify-center">
                    <div className="w-8 h-8 md:w-16 md:h-16 rounded-full bg-[#4F46E5] border border-white/10 flex items-center justify-center shadow-[0_10px_28px_rgba(79,70,229,0.5)]">
                      <Ic className="w-3.5 h-3.5 md:w-7 md:h-7 text-white" strokeWidth={1.7} />
                    </div>
                  </div>

                  {/* Bottom text */}
                  <p className="mt-3 md:mt-8 font-sf text-white text-[10px] md:text-base leading-snug md:leading-relaxed text-left md:text-left">
                    {c.heading}
                  </p>
                  <p className="mt-1.5 md:mt-3 font-sf text-white/70 text-[9px] md:text-[15px] leading-snug md:leading-relaxed text-left md:text-left">
                    {c.body}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
